export default "__VITE_ASSET__773878b4__"